import api from "../api";

export const getBlacklist = async () => {
  const res = await api.get<{ phones: string[]; emails: string[] }>(
    `blacklist`
  );

  return res.data;
};
